var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 14.6062V33.8385C13 35.882 17.8081 37.4446 23.8182 37.4446C29.8283 37.4446 34.6364 35.882 34.6364 33.8385V14.6062",
    stroke: "#0688FA",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8182 18.2121C29.7929 18.2121 34.6364 16.5976 34.6364 14.6061C34.6364 12.6145 29.7929 11 23.8182 11C17.8435 11 13 12.6145 13 14.6061C13 16.5976 17.8435 18.2121 23.8182 18.2121Z",
    stroke: "#0688FA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6364 24.2222C34.6364 26.2657 29.8283 27.8283 23.8182 27.8283C17.8081 27.8283 13 26.2657 13 24.2222",
    stroke: "#0688FA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStack);
export default __webpack_public_path__ + "static/media/stack.dcecb6923336f5be503665491bfe6a84.svg";
export { ForwardRef as ReactComponent };